import useGlobalQueries from './useGlobalQueries';

export default (feature) =>
  Boolean(useGlobalQueries().learnerSettings.data?.enabled_features?.includes(feature));
